import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-用户管理",
  "use": "icon-用户管理-usage",
  "viewBox": "0 0 160 160",
  "content": "<symbol viewBox=\"0 0 160 160\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-用户管理\">\n<circle cx=\"82.8001\" cy=\"58.6876\" r=\"24.1011\" stroke-width=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M136.013 125.204C136.013 109.132 112.561 96.1034 83.6313 96.1034C54.7015 96.1034 31.2493 109.132 31.2493 125.204\" stroke-width=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<circle cx=\"82.8\" cy=\"82.8\" r=\"69\" stroke-width=\"10\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/用户管理.svg
// module id = qkzt
// module chunks = 26